<p-menubar>
    <ng-template pTemplate="start">
        <label class="font-semibold">
            Atualização de NCM - XML vs Sistema
        </label>
    </ng-template>
    <ng-template pTemplate="end">
        <div class="flex gap-2">
            <button *ngIf="comparacoes.length > 0" 
                    type="button" 
                    pButton 
                    icon="pi pi-eye" 
                    label="Visualizar XMLs" 
                    (click)="visualizarTodosXmls()"
                    class="p-button-info"></button>
            
            <button *ngIf="comparacoes.length > 0" 
                    type="button" 
                    pButton 
                    icon="pi pi-file-excel" 
                    label="Exportar"
                    (click)="exportarResultado()" 
                    class="p-button-success"></button>
        </div>
    </ng-template>
</p-menubar>

<!-- Seção de Upload com toggle -->
<div class="grid p-fluid mt-3 pr-3 pl-3">
    <div class="col-12">
        <p-card>
            <!-- Header com título, botão de toggle e botões de ação -->
            <div class="flex align-items-center justify-content-between mb-3 pb-3 border-bottom-1 surface-border">
                <div class="flex align-items-center gap-2">
                    <button pButton type="button"
                        [icon]="secaoUploadExpandida ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                        (click)="toggleSecaoUpload()" class="p-button-rounded p-button-text p-button-sm"
                        pTooltip="{{secaoUploadExpandida ? 'Recolher' : 'Expandir'}}" tooltipPosition="right"></button>
                    <h5 class="m-0">Selecione os arquivos XML (DUIMP)</h5>
                    <p-badge *ngIf="!secaoUploadExpandida && arquivosSelecionados.length > 0"
                        [value]="arquivosSelecionados.length.toString()" severity="info"></p-badge>
                </div>

                <div class="flex gap-2" *ngIf="secaoUploadExpandida">
                    <input #fileInput type="file" accept=".xml" multiple (change)="onFileChange($event)"
                        style="display: none">

                    <button pButton type="button" icon="pi pi-plus" label="Selecionar XMLs" (click)="fileInput.click()"
                        class="p-button-sm p-button-outlined" style="white-space: nowrap;"></button>

                    <button pButton type="button" icon="pi pi-trash" label="Limpar Todos" (click)="limparArquivos()"
                        [disabled]="arquivosSelecionados.length === 0"
                        class="p-button-sm p-button-outlined p-button-danger" style="white-space: nowrap;"></button>
                </div>
            </div>

<!-- Conteúdo colapsável -->
<div *ngIf="secaoUploadExpandida">
    <div class="flex flex-column gap-3">
        <!-- Lista de arquivos selecionados -->
        <div *ngIf="arquivosSelecionados.length > 0">
            <p-divider align="left">
                <div class="inline-flex align-items-center">
                    <i class="pi pi-file mr-2"></i>
                    <b>Arquivos selecionados ({{arquivosSelecionados.length}})</b>
                </div>
            </p-divider>

            <div class="flex flex-column gap-2">
                <div *ngFor="let file of arquivosSelecionados; let i = index"
                    class="flex justify-content-between align-items-center p-3 surface-ground border-round">
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-file-pdf text-2xl text-primary"></i>
                        <div class="flex flex-column">
                            <span class="font-semibold">{{file.name}}</span>
                            <span class="text-sm text-500">{{formatFileSize(file.size)}}</span>
                        </div>
                    </div>
                    <button pButton type="button" icon="pi pi-times" (click)="removerArquivo(i)"
                        class="p-button-rounded p-button-text p-button-danger"></button>
                </div>
            </div>
        </div>

        <!-- Mensagem quando não há arquivos -->
        <div *ngIf="arquivosSelecionados.length === 0"
            class="text-center p-4 surface-ground border-round border-2 border-dashed surface-border">
            <i class="pi pi-cloud-upload text-4xl text-400 mb-3"></i>
            <p class="m-0 text-500">Nenhum arquivo selecionado</p>
            <p class="m-0 text-sm text-400">Clique em "Selecionar XMLs" para começar</p>
        </div>

        <!-- Mensagem de erro -->
        <div *ngIf="erroUpload" class="p-3 surface-ground border-round border-left-3 border-red-500">
            <div class="flex align-items-center gap-2">
                <i class="pi pi-exclamation-circle text-xl text-red-500"></i>
                <span class="text-red-600 font-semibold">{{erroUpload}}</span>
            </div>
        </div>

        <!-- Botão processar -->
        <div class="flex justify-content-center mt-3">
            <button pButton type="button" icon="pi pi-check" label="Processar XMLs"
                (click)="processarXMLs()" [disabled]="arquivosSelecionados.length === 0 || carregando"
                [loading]="carregando" class="p-button-lg p-button-success w-full md:w-auto"></button>
        </div>
    </div>
</div>

<!-- Filtros com botões de ação na mesma linha -->
<div *ngIf="comparacoes.length > 0" class="grid p-fluid mt-3 pr-3 pl-3">
    <div class="col-12">
        <p-card>
            <div class="flex align-items-center justify-content-between gap-3">
                <!-- Lado Esquerdo - Filtros -->
                <div class="flex gap-3 align-items-center">
                    <span class="font-semibold">Filtros:</span>
                    <p-checkbox [(ngModel)]="filtroNcmDiferente" 
                               [binary]="true" 
                               label="Apenas NCMs Diferentes"
                               (onChange)="atualizarCheckboxMaster()"
                               inputId="filtroNcmDiferente"></p-checkbox>
                    <p-checkbox [(ngModel)]="filtroPnNaoEncontrado" 
                               [binary]="true" 
                               label="Apenas PNs Não Encontrados"
                               (onChange)="atualizarCheckboxMaster()"
                               inputId="filtroPnNaoEncontrado"></p-checkbox>
                </div>

                <!-- Lado Direito - Botões de Ação -->
                <div class="flex gap-2 align-items-center" style="flex-shrink: 0;">
                    <button *ngIf="totalDiferentes > 0" type="button" pButton icon="pi pi-check-square"
                        label="Selecionar Todos Diferentes" (click)="toggleTodosDiferentes()"
                        class="p-button-sm p-button-outlined" style="white-space: nowrap;"></button>

                    <button *ngIf="totalSelecionados > 0" type="button" pButton icon="pi pi-check"
                        [label]="'Atualizar Selecionados (' + totalSelecionados + ')'" (click)="atualizarSelecionados()"
                        [disabled]="carregandoAtualizacao" class="p-button-sm p-button-warning"
                        style="white-space: nowrap;"></button>

                    <button *ngIf="totalDiferentes > 0" type="button" pButton icon="pi pi-sync"
                        label="Atualizar Todos Diferentes" (click)="atualizarTodosDiferentes()"
                        [disabled]="carregandoAtualizacao" class="p-button-sm p-button-warning"
                        style="white-space: nowrap;"></button>
                </div>
            </div>
        </p-card>
    </div>
</div>

<!-- Estatísticas -->
<div *ngIf="comparacoes.length > 0" class="grid p-fluid mt-3 pr-3 pl-3">
    <div class="col-12 md:col-3">
        <p-card>
            <div class="flex flex-column align-items-center">
                <span class="text-2xl font-bold text-blue-500">{{totalItens}}</span>
                <span class="text-sm text-500">Total de Itens</span>
            </div>
        </p-card>
    </div>
    <div class="col-12 md:col-3">
        <p-card>
            <div class="flex flex-column align-items-center">
                <span class="text-2xl font-bold text-green-500">{{totalIguais}}</span>
                <span class="text-sm text-500">NCMs Iguais</span>
            </div>
        </p-card>
    </div>
    <div class="col-12 md:col-3">
        <p-card>
            <div class="flex flex-column align-items-center">
                <span class="text-2xl font-bold text-orange-500">{{totalDiferentes}}</span>
                <span class="text-sm text-500">NCMs Diferentes</span>
            </div>
        </p-card>
    </div>
    <div class="col-12 md:col-3">
        <p-card>
            <div class="flex flex-column align-items-center">
                <span class="text-2xl font-bold text-red-500">{{totalNaoEncontrados}}</span>
                <span class="text-sm text-500">PNs Não Encontrados</span>
            </div>
        </p-card>
    </div>
</div>

<!-- Tabela de Resultados -->
<div *ngIf="comparacoes.length > 0" class="grid p-fluid mt-3 pr-3 pl-3">
    <div class="col-12">
        <p-table [value]="comparacoesExibidas" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
            [scrollable]="true" responsiveLayout="scroll" styleClass="p-datatable-sm p-datatable-gridlines">

            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 50px" class="text-center">
                        <p-checkbox [binary]="true" [(ngModel)]="checkboxMasterSelecionado"
                            (onChange)="toggleTodosDiferentes()" [disabled]="totalDiferentes === 0"></p-checkbox>
                    </th>
                    <th style="width: 150px">PN</th>
                    <th style="width: 100px">NCM XML</th>
                    <th style="width: 120px">NCM Sistema</th>
                    <th style="width: 80px" class="text-center">Status</th>
                    <th style="width: 200px">Arquivo</th>
                    <th>Descrição XML</th>
                    <th style="width: 100px" class="text-center">Ações</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr [ngClass]="{'bg-red-50': item.ncmSistema === 'PN NÃO ENCONTRADO', 
                                'bg-orange-50': item.ncmDiferente && item.ncmSistema !== 'PN NÃO ENCONTRADO',
                                'bg-green-50': !item.ncmDiferente}">
                    <td class="text-center">
                        <p-checkbox *ngIf="item.ncmDiferente && item.ncmSistema !== 'PN NÃO ENCONTRADO' && item.apeId"
                            [binary]="true" [(ngModel)]="item.selecionado"
                            (onChange)="toggleSelecao(item)"></p-checkbox>
                    </td>
                    <td>
                        <span class="font-semibold">{{item.pn}}</span>
                    </td>
                    <td>
                        <span class="font-mono">{{item.ncmXml}}</span>
                    </td>
                    <td>
                        <span class="font-mono" [ngClass]="{'text-red-600': item.ncmSistema === 'PN NÃO ENCONTRADO',
                                         'text-orange-600': item.ncmDiferente && item.ncmSistema !== 'PN NÃO ENCONTRADO',
                                         'text-green-600': !item.ncmDiferente}">
                            {{item.ncmSistema}}
                        </span>
                    </td>
                    <td class="text-center">
                        <p-tag *ngIf="item.ncmSistema === 'PN NÃO ENCONTRADO'" severity="danger" value="NÃO ENCONTRADO"
                            icon="pi pi-times-circle"></p-tag>
                        <p-tag *ngIf="item.ncmDiferente && item.ncmSistema !== 'PN NÃO ENCONTRADO'" severity="warning"
                            value="DIFERENTE" icon="pi pi-exclamation-triangle"></p-tag>
                        <p-tag *ngIf="!item.ncmDiferente" severity="success" value="IGUAL"
                            icon="pi pi-check-circle"></p-tag>
                    </td>
                    <td>
                        <span class="text-sm text-600">{{item.arquivo}}</span>
                    </td>
                    <td>
                        <span class="text-sm">{{item.descricao}}</span>
                    </td>
                    <td class="text-center">
                        <button *ngIf="item.ncmDiferente && item.ncmSistema !== 'PN NÃO ENCONTRADO' && item.apeId"
                            pButton type="button" icon="pi pi-sync" (click)="atualizarNcmIndividual(item)"
                            [disabled]="carregandoAtualizacao" class="p-button-rounded p-button-warning p-button-sm"
                            pTooltip="Atualizar NCM" tooltipPosition="left"></button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8" class="text-center">
                        Nenhum resultado encontrado com os filtros aplicados.
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- Loading Overlay -->
<div *ngIf="carregando" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
    <p class="mt-3 text-white font-semibold">Processando XMLs...</p>
</div>